/** Metadata only. Milliseconds are never inferred from legacy response fields. */
export const TIMING_VERSION = 'foreground_elapsed_v1' as const;
export const timingSurfaces = ['reading', 'video', 'exercise', 'quiz', 'selfExplanation',
  'survey', 'review', 'code', 'demonstration', 'aiHelp', 'chat'] as const;
export type TimingSurface = typeof timingSurfaces[number];
export interface TimingScope {
  context: 'course' | 'topic' | 'platform';
  surface: TimingSurface;
  courseId?: string;
  chapterId?: string;
  sectionId?: string;
  topicId?: string;
  activityId?: string;
  contentItemId?: string;
  platformKey?: 'workspace';
}
export type TimingReason = 'checkpoint' | 'navigation' | 'hidden' | 'blur' | 'pause' |
  'suspension' | 'pagehide' | 'logout' | 'queue_loss' | 'unsupported' | 'rotation';
/** Self-contained segments allow reordered delivery, without mutating an open record. */
export interface TimingPacket {
  timingVersion: typeof TIMING_VERSION;
  visitId: string;
  timelineId: string;
  sequence: number;
  kind: 'open' | 'interval' | 'close';
  scope: TimingScope;
  contentRevision: string | null;
  startOffsetMs: number;
  endOffsetMs: number;
  elapsedMs: number;
  reason: TimingReason;
  lossDetected: boolean;
  coordination: 'unverified';
}
export interface ForegroundDuration {
  unit: 'ms';
  recordedMs: number | null;
  uniqueRecordedMs: number | null;
  bySurface: Partial<Record<TimingSurface, number>>;
  availability: 'available' | 'partial' | 'unavailable';
  reasons: string[];
  visits: number;
}
